// extracted by mini-css-extract-plugin
module.exports = {"switchnav":"SwitchNav_switchnav__1i06N","switchnav__btn":"SwitchNav_switchnav__btn__cEjH6"};